"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _toConsumableArray2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/web.dom.iterable");

var _createForOfIteratorHelper2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper"));

require("core-js/modules/es6.function.name");

var _objectSpread2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/opt/build/repo/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _path = _interopRequireDefault(require("path"));

var _utils = require("@/utils");

var _role = require("@/api/role");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultRole = {
  id: '',
  displayName: '',
  role: '',
  status: false,
  name: '',
  description: '',
  routes: []
};
var listQuery = {
  id: undefined,
  role: undefined,
  status: undefined
};
var _default = {
  name: 'AccountPermission',
  data: function data() {
    return {
      role: Object.assign({}, defaultRole),
      routes: [],
      rolesList: [],
      dialogVisible: false,
      dialogType: 'new',
      checkStrictly: false,
      listQuery: this.$_.clone(listQuery),
      total: 0,
      page: 1,
      limit: 20,
      roleOptions: [],
      statusOptions: [{
        name: '启用',
        value: true
      }, {
        name: '禁用',
        value: false
      }],
      defaultProps: {
        children: 'children',
        label: 'title'
      }
    };
  },
  computed: {
    routesData: function routesData() {
      return this.routes;
    }
  },
  created: function created() {
    this.getRoutes();
    this.getRoles();
  },
  methods: {
    getRoutes: function () {
      var _getRoutes2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _role.getRoutes)();

              case 2:
                res = _context.sent;
                this.serviceRoutes = res.data;
                this.routes = this.generateRoutes(res.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRoutes() {
        return _getRoutes2.apply(this, arguments);
      }

      return getRoutes;
    }(),
    getRoles: function () {
      var _getRoles2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
                  skip: (this.page - 1) * this.limit,
                  limit: this.limit
                });
                _context2.next = 3;
                return (0, _role.getRoles)(params);

              case 3:
                res = _context2.sent;
                this.rolesList = res.data.roles;
                this.total = res.data.total;
                this.roleOptions = this.rolesList.map(function (item) {
                  return {
                    name: item.description,
                    value: item.id
                  };
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRoles() {
        return _getRoles2.apply(this, arguments);
      }

      return getRoles;
    }(),
    handleAddRole: function handleAddRole() {
      this.role = Object.assign({}, defaultRole);

      if (this.$refs.tree) {
        this.$refs.tree.setCheckedNodes([]);
      }

      this.dialogType = 'new';
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(scope) {
      var _this = this;

      console.log('scope :', scope.row.routes);
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.checkStrictly = true;
      this.role = (0, _utils.deepClone)(scope.row);
      this.$nextTick(function () {
        var routes = _this.generateRoutes(_this.role.routes);

        console.log('routes :', routes);
        console.log('this.generateArr(routes) :', _this.generateArr(routes));

        _this.$refs.tree.setCheckedNodes(_this.generateArr(routes));

        _this.checkStrictly = false;
      });
    },
    confirmRole: function () {
      var _confirmRole = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var isEdit, checkedKeys, index, _yield$addRole, data, _this$role, description, id, name;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isEdit = this.dialogType === 'edit';
                checkedKeys = this.$refs.tree.getCheckedKeys();
                this.role.routes = this.generateTree((0, _utils.deepClone)(this.serviceRoutes), '/', checkedKeys);

                if (!isEdit) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 6;
                return (0, _role.updateRole)(this.role.id, this.role);

              case 6:
                index = 0;

              case 7:
                if (!(index < this.rolesList.length)) {
                  _context3.next = 14;
                  break;
                }

                if (!(this.rolesList[index].id === this.role.id)) {
                  _context3.next = 11;
                  break;
                }

                this.rolesList.splice(index, 1, Object.assign({}, this.role));
                return _context3.abrupt("break", 14);

              case 11:
                index++;
                _context3.next = 7;
                break;

              case 14:
                _context3.next = 22;
                break;

              case 16:
                _context3.next = 18;
                return (0, _role.addRole)(this.role);

              case 18:
                _yield$addRole = _context3.sent;
                data = _yield$addRole.data;
                this.role.id = data.id;
                this.rolesList.push(this.role);

              case 22:
                _this$role = this.role, description = _this$role.description, id = _this$role.id, name = _this$role.name;
                this.dialogVisible = false;
                this.$notify({
                  title: 'Success',
                  dangerouslyUseHTMLString: true,
                  message: "\n            <div>\u89D2\u8272 ID: ".concat(id, "</div>\n            <div>\u89D2\u8272 \u540D\u5B57: ").concat(name, "</div>\n            <div>\u63CF\u8FF0: ").concat(description, "</div>\n          "),
                  type: 'success'
                });

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function confirmRole() {
        return _confirmRole.apply(this, arguments);
      }

      return confirmRole;
    }(),
    handleStatus: function () {
      var _handleStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row, status) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _role.updateRole)(row.row.id, {
                  status: status
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function handleStatus(_x, _x2) {
        return _handleStatus.apply(this, arguments);
      }

      return handleStatus;
    }(),
    updateLimit: function updateLimit(val) {
      this.limit = val;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      this.page = 1;
      this.getRoles();
    },
    resetForm: function resetForm() {
      this.listQuery = this.$_.clone(listQuery);
      this.handleFilter();
    },
    // 转换路由成el-tree数据结构
    generateRoutes: function generateRoutes(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      var a = routes.filter(function (item) {
        return item.name !== 'DashboardManerger';
      });
      console.log('a :', a);
      var res = [];

      var _iterator = (0, _createForOfIteratorHelper2.default)(routes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var route = _step.value;

          // console.log('route1 :', route)
          if (route.filter) {
            console.log('route :', route);
            continue;
          }

          var data = {
            path: _path.default.resolve(basePath, route.path),
            title: route.meta && route.meta.title
          };

          if (route.children) {
            data.children = this.generateRoutes(route.children, data.path);
          }

          res.push(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return res;
    },
    generateArr: function generateArr(routes) {
      var _this2 = this;

      var data = [];
      routes.forEach(function (route) {
        data.push(route);

        if (route.children) {
          var temp = _this2.generateArr(route.children);

          if (temp.length > 0) {
            data = [].concat((0, _toConsumableArray2.default)(data), (0, _toConsumableArray2.default)(temp));
          }
        }
      });
      return data;
    },
    generateTree: function generateTree(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      var checkedKeys = arguments.length > 2 ? arguments[2] : undefined;
      var res = [];
      console.log('checkedKeys :', checkedKeys);

      var _iterator2 = (0, _createForOfIteratorHelper2.default)(routes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var route = _step2.value;

          var routePath = _path.default.resolve(basePath, route.path);

          if (route.children) {
            route.children = this.generateTree(route.children, routePath, checkedKeys);
          }

          if (checkedKeys.includes(routePath) || route.children && route.children.length >= 1) {
            res.push(route);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return res;
    }
  }
};
exports.default = _default;